import { Tag } from 'antd';
import dayjs from 'dayjs';
import { InvoiceStatus, InvoiceType } from './constants/tagColors';
import { createInvoiceActionColumn } from './createInvoiceActionColumn';

/**
 * Creates standard invoice columns configuration for data tables.
 * This utility function eliminates code duplication by generating the common structure
 * used across multiple invoice list components.
 *
 * @param {Object} params - Configuration parameters
 * @param {Function} params.t - Translation function from useTranslation hook
 * @param {Function} params.dispatchAPI - API dispatch function
 * @param {Function} params.message - Error message function
 * @param {Function} params.setRefreshData - Function to set refresh data state
 * @param {boolean} params.refreshData - Current refresh data state
 * @returns {Array} Array of column configuration objects
 */
export const createInvoiceColumns = ({
  t,
  dispatchAPI,
  message,
  setRefreshData,
  refreshData
}) => [
  {
    title: t('customerinvoices.form.reference'),
    key: 'reference',
    render: (reference) => reference || '-',
    dataIndex: 'reference'
  },
  {
    title: t('customerinvoices.form.type'),
    key: 'type',
    render: (type) => (
      <Tag color={InvoiceType[type]}>{t(`customerinvoices.tags.${type}`)}</Tag>
    ),
    dataIndex: 'type'
  },
  {
    title: t('customerinvoices.form.emission_date'),
    key: 'emission_date',
    dataIndex: 'emission_date',
    render: (emission_date) =>
      (emission_date && dayjs(emission_date).format('DD/MM/YYYY')) || '-'
  },
  {
    title: t('customerinvoices.form.total_ttc'),
    key: 'total_ttc',
    dataIndex: 'total_ttc'
  },
  {
    title: t('customerinvoices.form.paid'),
    key: 'payment',
    dataIndex: 'payment',
    render: (payment) => payment?.reduce((acc, obj) => acc + obj.amount, 0)
  },
  {
    title: t('customerinvoices.form.status'),
    key: 'status',
    render: (status) => (
      <Tag color={InvoiceStatus[status]}>
        {t(`customerinvoices.tags.${status}`)}
      </Tag>
    ),
    dataIndex: 'status'
  },
  createInvoiceActionColumn({
    t,
    dispatchAPI,
    message,
    setRefreshData,
    refreshData
  })
];
